import { GridColDef, DataGrid, GridRowParams } from "@mui/x-data-grid";
import { useState } from "react";
import { formatDateTime } from "../../utils";
import { DeviceSessionDto } from "./dtos/DeviceSessionDto";
import { useVillageWifiHttp } from "./hooks/useVillageWifiHttp";
import { DeviceSessionsDialog } from "./dialogs/DeviceSessionsDialog";

type LatestDeviceSessionsProps = {

    latestDeviceSessions: DeviceSessionDto[ ];

};

const columns: GridColDef[ ] = [

    {
        field: 'mac',
        headerName: 'Device MAC',
        width: 230,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },
    
    {
        field: 'authTime',
        headerName: 'Last Auth Time',
        width: 200,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
        renderCell: ( params => formatDateTime( params.row.authTime ))
    },

    {
        field: 'villageCode',
        headerName: 'Last Login Village',
        width: 150,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },
    
    {
        field: 'accessPointMac',
        headerName: 'Last Login AP MAC',
        width: 230,
        headerAlign: 'center',
        align: 'center',
        // type: 'boolean'
    },

];


const dataGridSx = {

    cursor: 'pointer',
    '.MuiDataGrid-columnHeaderTitle': { 
        fontWeight: 'bold !important',
        overflow: 'visible !important'
    },

    '.MuiDataGrid-cell:focus': {
        outline: 'none'
    }

};


export const LatestDeviceSessions : React.FC< LatestDeviceSessionsProps > = ( props : LatestDeviceSessionsProps ) => {

    const { latestDeviceSessions } = props;

    const [ deviceSessions, setDeviceSessions ] = useState< DeviceSessionDto[ ]>( [ ] );
    const [ deviceSessionsDialogOpen, setDeviceSessionsDialogOpen ] = useState< boolean >( false );
    const [ isLoading, setIsLoading ] = useState< boolean >( false );
    const [ pageSize, setPageSize ] = useState< number> ( 10 );


    const { getDeviceSessions } = useVillageWifiHttp( );


    const handleDeviceSessionsDialogOk = ( ) => setDeviceSessionsDialogOpen( false );


    const handleSelectRow = async( latestDeviceSession : DeviceSessionDto ) => {

        if( isLoading ){

            return;

        }

        setIsLoading( true );
        const deviceSessions = await getDeviceSessions( latestDeviceSession.mac, latestDeviceSession.residentId );
        setIsLoading( false );

        if( deviceSessions && deviceSessions.length > 0 ){

            setDeviceSessions( deviceSessions );
            setDeviceSessionsDialogOpen( true );

        }

    };


    return(

        <>
            <DataGrid
                autoHeight={ true }    
                columns={ columns }
                loading={ isLoading }
                isRowSelectable={ _ => !isLoading }
                getRowId={ _ => Math.floor(Math.random() * 100_000_000) }
                onPageSizeChange={ ( newPageSize ) => setPageSize( newPageSize ) }
                onRowClick={ ( params: GridRowParams, _, __ ) => handleSelectRow( params.row ) }
                pageSize={ pageSize }
                pagination
                rows={ latestDeviceSessions }
                rowsPerPageOptions={ [ 10, 50, 100 ] }
                sx={{ ...dataGridSx, width: '820px', boxShadow: 5 }}
                
            />

            <DeviceSessionsDialog
                deviceSessions={ deviceSessions }
                dialogOpen={ deviceSessionsDialogOpen }
                handleOk={ handleDeviceSessionsDialogOk }
            />
        </>

    );

};